import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { forWhoScenes } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ForWhoSection() {
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-86" data-mp="2c85eizmk0sjh">
      <Container data-id="element-87" data-mp="2c5asx4rt11oh">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-88" data-mp="285s96cbpywn8">
          <SectionTag tone="white" data-id="element-89" data-mp="287d07rytrxgc">¿Es para ti?</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-90" data-mp="236fn3tso9tlp">
            ¿Te suena alguna de estas escenas?
          </h2>
          <p className="mt-3 text-base text-mp-gray" data-id="element-91" data-mp="1y9fepc8coerf">
            Si te identificas con 2 o más, Maestro en Pista fue diseñado exactamente para ti.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-92" data-mp="3sku5zxh0em9a">
          {forWhoScenes.map((scene, i) => <motion.div key={scene.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i % 3 * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-93" data-mp="1sa2v6b49yz33" data-mpi={i}>
              <p className="font-heading text-xs text-mp-lime" data-id="element-94" data-mp="1nct7p10g4xhw">{scene.number}</p>
              <p className="mt-2 font-heading text-base uppercase tracking-wide text-mp-white" data-id="element-95" data-mp="2b1cf7ebo968x">{scene.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-96" data-mp="2g1qbjz3wurr4">{scene.copy}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}